/**
 * @generated SignedSource<<944edeb560723b9a5c02127aac5302a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountAvatarMutation$variables = {
  key?: string | null;
};
export type AccountAvatarMutation$data = {
  readonly updateAvatar: {
    readonly user: {
      readonly avatar: {
        readonly downloadUrl: string | null;
        readonly filename: string | null;
        readonly key: any;
        readonly thumbnailUrl: string | null;
        readonly uploadedOn: any | null;
      } | null;
      readonly id: string;
    } | null;
  } | null;
};
export type AccountAvatarMutation = {
  response: AccountAvatarMutation$data;
  variables: AccountAvatarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "storageobject",
        "variableName": "key"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadedOn",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountAvatarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAvatarMutationPayload",
        "kind": "LinkedField",
        "name": "updateAvatar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StorageObjectNode",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v3/*: any*/),
                    "action": "NONE",
                    "path": "updateAvatar.user.avatar.key"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountAvatarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAvatarMutationPayload",
        "kind": "LinkedField",
        "name": "updateAvatar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StorageObjectNode",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d04a4339957331685e755f4b4c1d2c16",
    "id": null,
    "metadata": {},
    "name": "AccountAvatarMutation",
    "operationKind": "mutation",
    "text": "mutation AccountAvatarMutation(\n  $key: String\n) {\n  updateAvatar(input: {storageobject: $key}) {\n    user {\n      id\n      avatar {\n        key\n        filename\n        downloadUrl\n        thumbnailUrl\n        uploadedOn\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd1b4e6576ce950a9adf492bcec20cef";

export default node;
